import React from 'react'
import HeaderLink from '../HeaderLink'

const DropDown =(({ id, link , children,isActive})=>(
	<div className={isActive === true ? "dropdown_menu js-active" : 'dropdown_menu'} data-id={id}> 
		{	
			children && children.map((_link,_i)=>(
				<HeaderLink url={_link.url} text={_link.caption} target={_link.target} key={_i} isActive={_link.isActive}/>
			))
		}
	</div>
))

export default DropDown


// WEBPACK FOOTER //
// ./src/Components/Dropdown/index.js